import { createAsyncThunk } from '@reduxjs/toolkit';
import {
    getAssociatedDocumentListQuery as getAssociatedDocumentListQueryApi,
    addAssociatedDocument as addAssociatedDocumentApi,
    getAssociatedDocument as getAssociatedDocumentApi,
    updateAssociatedDocument as updateAssociatedDocumentApi,
    deleteAssociatedDocument as deleteAssociatedDocumentApi,
    downloadAssociatedDocument as downloadAssociatedDocumentApi,
} from '../../helpers/associated_document/api_helper';
import { toast } from 'react-toastify';

/**
 * Get Associated Document list with query parameters
 */
export const getAssociatedDocumentListQuery = createAsyncThunk(
    'associatedDocument/getListQuery',
    async (params, { rejectWithValue }) => {
        try {
            const response = await getAssociatedDocumentListQueryApi(params);
            return response;
        } catch (error) {
            toast.error('Error al cargar los documentos asociados');
            return rejectWithValue(error);
        }
    }
);

/**
 * Add Associated Document
 */
export const addAssociatedDocumentThunk = createAsyncThunk(
    'associatedDocument/add',
    async (data, { rejectWithValue }) => {
        try {
            const response = await addAssociatedDocumentApi(data);
            toast.success('Documento asociado creado exitosamente');
            return response;
        } catch (error) {
            toast.error('Error al crear el documento asociado');
            return rejectWithValue(error);
        }
    }
);

/**
 * Get Associated Document by ID
 */
export const getAssociatedDocumentThunk = createAsyncThunk(
    'associatedDocument/get',
    async (id, { rejectWithValue }) => {
        try {
            const response = await getAssociatedDocumentApi(id);
            return response;
        } catch (error) {
            toast.error('Error al obtener el documento asociado');
            return rejectWithValue(error);
        }
    }
);

/**
 * Update Associated Document
 */
export const updateAssociatedDocumentThunk = createAsyncThunk(
    'associatedDocument/update',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await updateAssociatedDocumentApi(id, data);
            toast.success('Documento asociado actualizado exitosamente');
            return response;
        } catch (error) {
            toast.error('Error al actualizar el documento asociado');
            return rejectWithValue(error);
        }
    }
);

/**
 * Delete Associated Document (soft delete)
 */
export const deleteAssociatedDocumentThunk = createAsyncThunk(
    'associatedDocument/delete',
    async (id, { rejectWithValue }) => {
        try {
            const response = await deleteAssociatedDocumentApi(id);
            toast.success('Documento asociado eliminado exitosamente');
            return response;
        } catch (error) {
            toast.error('Error al eliminar el documento asociado');
            return rejectWithValue(error);
        }
    }
);

/**
 * Download Associated Document file
 */
export const downloadAssociatedDocumentThunk = createAsyncThunk(
    'associatedDocument/download',
    async ({ id }, { rejectWithValue }) => {
        try {
            // Backend returns { url, filename, extension, mime_type, size }
            const response = await downloadAssociatedDocumentApi(id);
            const fileUrl = response?.url || response?.data?.url;

            if (!fileUrl) {
                toast.error('No se pudo obtener la URL del archivo');
                return rejectWithValue('No URL');
            }

            window.open(fileUrl, '_blank', 'noopener,noreferrer');
            toast.success('Documento abierto exitosamente');
            return { url: fileUrl, filename: response?.filename || '' };
        } catch (error) {
            toast.error('Error al descargar el documento');
            return rejectWithValue(error);
        }
    }
);
